import useSWR from 'swr';
import { fetcherGet } from './httpClient';
import { useAuth } from '../../context/AuthProvider';
import type { JobProductsResponse } from '../contracts/JobProductsResponse';

export const useGetJobProducts = (
  jobId?: string,
  status?: string,
  limit?: number,
  options?: { refreshInterval?: number }
) => {
  const { session } = useAuth();
  let path = `jobs/${jobId}/products?`;
  if (status === 'failed') {
    path += `status=${status}&`;
  }
  if (status === 'unavailable') {
    path += `returnUnavailable=true&`;
  }
  if (limit) {
    path += `limit=${limit}&`;
  }

  return useSWR<JobProductsResponse, Error>(
    session?.access_token && jobId ? [path, session.access_token] : null,
    () => fetcherGet(path, { arg: {}, token: session?.access_token ?? '' }),
    {
      refreshInterval: options?.refreshInterval,
    }
  );
};
